module.exports = __webpack_public_path__ + "img/jdc.b91859ca.png";